/* eslint-disable no-undef */
"use strict";
use(function () {
  const packageName = properties.get("utag-model", "");
  return packageName != null && !packageName.isEmpty() ? packageName : "com.codebay.bhg.barcelo.web.core.models.tealium.BaseUTagData";
});
